const stateClass = {
  0: 'down',
  1: 'up',
  2: 'refresh'
}
export default {
  props: {
    // 上拉加载的高度
    offset: {
      type: Number,
      default: 64
    },
    enableInfinite: {
      // 是否可以上拉加载
      type: Boolean,
      default: false
    },
    // 加载函数
    onInfinite: {
      type: Function,
      default: () => {},
      require: false
    },
    dataList: {
      // 控制加载的其他数据
      required: false
    },
    // 是否显示标题栏
    hasNavbar: {
      type: Boolean,
      default: true
    },
    // 是否显示关闭按钮
    hasClosed: {
      type: Boolean,
      default: true
    },
    // 标题内容
    title: {
      type: String,
      default: ''
    },
    // 主题色
    theme: {
      type: String,
      default: 'dark'
    },
    // 是否无下边框
    noBottomBorder: {
      type: Boolean,
      default: false
    },
    onScroll: {
      type: Function,
      default: () => {}
    },
    leftFunc: {
      // 左边icon点击的事件
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      top: 0,
      state: 0,
      startX: 0,
      startY: 0,
      hasMore: true, // 是否显示加载更多
      touching: false, // 是否在touch中，判断样式字段
      downFlag: false, // 是否加载中
      infiniteLoading: false, // 是否正在加载，是则不再请求
      stateClass
    }
  },
  methods: {
    handleTouchStart(e) {
      this.startY = (e.targetTouches[0] || {}).pageY || 0
      this.startX = (e.targetTouches[0] || {}).pageX || 0
      this.touching = true // 留着有用，不能删除
      if (this.enableInfinite) {
        this.hasMore = true
        if (this.dataList) {
          this.dataList.noFlag = false
        }
      }
    },
    handleTouchMove(e) {
      const diff = ((e.targetTouches[0] || {}).pageY || 0) - this.startY
      this.top = diff ** 0.8 + (this.state === 2 ? this.offset : 0)
      if (this.state === 2) {
        // 刷新中
        return
      }
      this.state = this.top >= this.offset ? 1 : 0
      this.hasMore = this.enableInfinite && !this.top && !this.state
    },
    handleTouchEnd(e) {
      this.touching = false
      if (this.state === 2) {
        // in refreshing
        this.state = 2
        this.top = this.offset
        return
      }
      if (this.top >= this.offset) {
        // do refresh
      } else {
        // cancel refresh
        this.state = 0
        this.top = 0
      }
      // 用于判断滑动是否在原地 ----begin
      const endX = e.changedTouches[0].pageX || 0
      const endY = e.changedTouches[0].pageY || 0
      const dy = this.startY - endY
      const dx = endX - this.startX
      // --------end--------
      // 判断滑动距离，足够长的时候刷新/加载
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) {
        const node = this.$el.querySelector('.page-content')
        if (!node) {
          return
        }
        const outerHeight = node.clientHeight
        const innerHeight = node.scrollHeight
        const scrollTop = node.scrollTop
        const bottom = innerHeight - outerHeight - scrollTop

        if (scrollTop && !this.state && bottom <= this.offset * 4 && this.enableInfinite) {
          this.downFlag = true
          this.infinite()
        } else {
          this.hasMore = false
          this.downFlag = false
        }
      }
    },
    infinite() {
      if (!this.infiniteLoading) {
        this.infiniteLoading = true
        this.onInfinite(this.infiniteDone)
      }
    },
    infiniteDone() {
      this.hasMore = false
      this.infiniteLoading = false
    }
  },
  mounted() {
    this.hasMore = this.enableInfinite
  },
  beforeUpdate() {
    this.hasMore = this.enableInfinite
  }
}
